<template>
  <div class="create-profile-wrapper">
    <BaseLoading opaque :spinning="athleteLoading">
      <div class="container">
        <div class="heading">
          <h1 class="head-title">Add New Profile</h1>
        </div>
        <div class="form-progress-wrap" id="form-top">
          <a-steps :current="current" @change="onChange">
            <a-step
              v-for="item in steps"
              :key="item.title"
              :title="item.title"
              :description="item.description"
            >
              <a-icon slot="icon" :type="item.icon" />
            </a-step>
          </a-steps>
          <div class="steps-content">
            <GeneralInformation
              ref="general-information"
              v-if="steps[current].content === 'general-information'"
              @save="handleStepChange"
            />
            <PlayerDetails
              ref="Players-details"
              v-if="steps[current].content === 'Players-details'"
              @save="handleStepChange"
            />
            <ScoutingImages
              ref="scouting-images"
              v-else-if="steps[current].content === 'scouting-images'"
              @save="handleStepChange"
            />
            <AddVideos
              :id="id"
              ref="add-videos"
              v-else-if="steps[current].content === 'add-videos'"
              @save="handleStepChange"
            />
            <AcademicInfo
              ref="academic-info"
              v-else-if="steps[current].content === 'academic-info'"
              @save="handleStepChange"
            />
            <TeamsPlayed
              :id="id"
              ref="teams-played"
              v-else-if="steps[current].content === 'teams-played'"
              @save="handleStepChange"
            />
            <SocialMedia
              ref="social-media"
              v-else-if="steps[current].content === 'social-media'"
              @save="handleStepChange"
            />
            <AddPayment
              ref="add-payment"
              v-else-if="steps[current].content === 'add-payment'"
              @save="handleStepChange"
            />
          </div>
        </div>
      </div>
    </BaseLoading>
  </div>
</template>
<script>
import GeneralInformation from "./GeneralInformation";
import PlayerDetails from "./PlayerDetails";
import ScoutingImages from "./ScoutingImages";
import AddVideos from "./AddVideos";
import AcademicInfo from "./AcademicInfo";
import TeamsPlayed from "./TeamsPlayed";
import SocialMedia from "./SocialMedia";
import AddPayment from "./AddPayment";
import { Notification } from "ant-design-vue";
import { mapGetters } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("users");
const STORE_KEY = "athleteStore";

export default {
  name: "CreateProfile",
  props: ["id"],
  components: {
    GeneralInformation,
    PlayerDetails,
    ScoutingImages,
    AddVideos,
    AcademicInfo,
    TeamsPlayed,
    SocialMedia,
    AddPayment
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "General Information",
          icon: "user",
          content: "general-information"
        },
        {
          title: "Players Details",
          icon: "form",
          content: "Players-details"
        },
        {
          title: "Academic Information",
          icon: "book",
          content: "academic-info"
        },
        {
          title: "Scouting Images",
          icon: "file-image",
          description: "(Up to 2)",
          content: "scouting-images"
        },
        {
          title: "Videos",
          icon: "video-camera",
          description: "(Up to 3)",
          content: "add-videos"
        },
        {
          title: "Teams Played",
          icon: "team",
          content: "teams-played"
        },
        {
          title: "Social Media",
          icon: "mobile",
          content: "social-media"
        },
        {
          title: "Add Payment",
          icon: "dollar",
          content: "add-payment"
        }
      ]
    };
  },
  mounted() {
    window.scrollTo({ top: 0});
    this.athleteId ? this.dispatcher() : this.reRouteIfIncomplete();
  },
  computed: {
    currentTab() {
      return this.steps[this.current].content;
    },
    ...mapGetters({
      athlete: `${STORE_KEY}/athlete`,
      athleteLoading: `${STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.id || this.$route.params.id;
    }
  },
  methods: {
    async dispatcher() {
      await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
      this.current = this.athlete.registerPageCompleted || 0;
    },
    handleStepChange(current) {
      this.current = current;
    },
    onChange(current) {
      const validateNumbers = [0, 1, 2];
      if (current > this.current) {
        let valid = this.$refs[this.currentTab].validateForm();
        if (
          validateNumbers.includes(current) &&
          this.athlete.registerPageCompleted < current
        ) {
          valid = false;
        }
        if (valid) this.current = current;
        else
          Notification.error({
            message: "Error",
            description: "Please fill in the required values to go to next step"
          });
      } else {
        this.current = current;
      }
    },
    reRouteIfIncomplete() {
      UserRepository.getUsersInfo().then(response => {
        const athleteProfiles = response.data.athleteProfiles;
        if (athleteProfiles.length === 0) return;
        if (
          athleteProfiles.some(
            profile => profile.profileType === "Incomplete"
          ) ||
          !athleteProfiles.some(profile => profile.profileType === "Paid")
        )
          window.location.replace(`${window.location.origin}/404`);
      });
    }
  },
  watch: {
    "athlete.registerPageCompleted": function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.current = newVal;
      }
    }
  }
};
</script>
<style lang="scss">
.steps-action {
  margin-top: 24px;
}

// Custom scss
.create-profile-wrapper {
  padding: 60px 0;
  .heading {
    .head-title {
      text-align: center;
      color: #d23129;
      text-transform: uppercase;
      font-size: 22px;
      line-height: 32px;
    }
  }
  .form-progress-wrap {
    .ant-steps {
      .ant-steps-item {
        margin: 0;
        overflow: visible;
        .ant-steps-item-container {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          margin: 0 5px;
          position: relative;
          &::after {
            position: absolute;
            top: 20px;
            left: 60%;
            display: block;
            width: 100%;
            height: 1px;
            z-index: 1;
            background: #afafaf;
            content: "";
          }
        }
        .ant-steps-item-content {
          max-width: 100%;
          text-align: center;
        }
        .ant-steps-item-icon {
          margin-right: 0;
          margin-bottom: 15px;
          width: 40px !important;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          .ant-steps-icon {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            background: #293187;
            z-index: 2;
            .anticon {
              font-size: 16px;
              color: #fff;
            }
          }
        }
        .ant-steps-item-title {
          color: rgba(0, 0, 0, 0.7) !important;
          font-size: 15px;
          line-height: 20px;
          font-weight: 500;
          overflow: visible;
          white-space: break-spaces;
          display: table-caption;
          padding: 0 !important;
          &::after {
            display: none;
          }
        }
        .ant-steps-item-description {
          font-weight: 500;
        }
        &::after {
          margin-left: 8px;
        }
        &.ant-steps-item-active {
          .ant-steps-item-title {
            color: #d23129 !important;
          }
        }
        &.ant-steps-item-finish {
          .ant-steps-item-container {
            &::after {
              background: #293187;
              height: 2px;
            }
          }
          .ant-steps-item-title {
            color: green !important;
          }
        }
        &:last-child {
          width: 142px;
          .ant-steps-item-container {
            &::after {
              display: none;
            }
          }
        }
      }
    }
    .steps-content {
      margin-top: 80px;
      min-height: 200px;
      text-align: center;
      .box-wrapper {
        margin-bottom: 0;
        padding: 55px 40px;
        border: 1px dashed #e9e9e9;
        border-radius: 6px;
        background-color: #f0f0f0;
      }
    }
    .steps-action {
      display: flex;
      justify-content: center;
    }
  }

  .ant-btn-primary {
    &.next-button {
      margin-top: 40px;
    }
  }
}

@media only screen and (max-width: 991px) {
  .create-profile-wrapper {
    .form-progress-wrap {
      .ant-steps {
        overflow-x: scroll;
        .ant-steps-item {
          min-width: 115px;
          &:last-child {
            width: 115px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .create-profile-wrapper {
    .form-progress-wrap {
      .steps-content {
        .box-wrapper {
          padding: 30px 20px;
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .create-profile-wrapper {
    padding: 30px 0;
    .heading {
      .head-title {
        font-size: 18px;
        line-height: 26px;
      }
    }
    .form-progress-wrap {
      .ant-steps {
        display: flex;
      }
      .ant-steps-item {
        margin-left: 0;
        .ant-steps-item-tail {
          display: none !important;
        }
        .ant-steps-item-container {
          margin: 0 10px;
        }
        &::after {
          display: none;
        }
      }
      .steps-content {
        margin-top: 40px;
      }
    }
  }
}
</style>
